import $http from '../http';
let complaintPath = '/tio/complain/v2/api/';

export const menuList = data => {//处理组首页菜单
    return $http({
        url: complaintPath + 'menu/workbechComplainCount',
        data,
        method: 'POST'
    });
};
// export const syntheticalWarning= data => {//综合预警
//     return $http({
//         url: complaintPath + 'newWorkbench/workbench/syntheticalWarning',
//         method: 'POST',
//         data
//     });
// };

// export const emergency= data => {//紧急程度
//     return $http({
//         url: complaintPath + 'newWorkbench/workbench/emergency',
//         method: 'POST',
//         data
//     });
// };
// export const timeLimit= data => {//显示预警
//     return $http({
//         url: complaintPath + 'newWorkbench/workbench/timeLimit',
//         method: 'POST',
//         data
//     });
// };
export const queryList= data => {//工作台查询列表接口
    return $http({
        url: complaintPath + 'qywx/query/list',
        data,
        method: 'POST'
    });
};
export const queryVerifyList= data => {//拆单待审核
    return $http({
        url: complaintPath + 'complaint/handle/queryVerifyList',
        data,
        method: 'POST'
    });
};
export const notHandleComplainList= data => {//待处理
    return $http({
        url: complaintPath + 'complaint/handle/notHandleComplainList',
        data,
        method: 'POST'
    });
};
export const notAcceptComplainList= data => {//待响应
    return $http({
        url: complaintPath + 'complaint/handle/notAcceptComplainList',
        data,
        method: 'POST'
    });
};
export const listSuperviseToAccept= data => {//督办件待受理
    return $http({
        url: complaintPath + 'complaint/handle/listSuperviseToAccept',
        data,
        method: 'POST'
    });
};
export const listAwaitReport= data => {//上报待审核
    return $http({
        url: complaintPath + 'complaint/handle/listAwaitReport',
        data,
        method: 'POST'
    });
};
export const listDepEnterpriseAwaitHandle= data => {//部门和企业待处理
    return $http({
        url: complaintPath + 'complaint/handle/listDepEnterpriseAwaitHandle',
        data,
        method: 'POST'
    });
};
export const detailInfo= data => {//投诉详情接口
    return $http({
        url: complaintPath + 'qywx/details/info',
        data,
        method: 'POST'
    });
};
export const unAccept= data => {//投诉不予受理
    return $http({
        url: complaintPath + 'unaccept/operation/unAccept',
        data,
        method: 'POST'
    });
};
export const informationSupplement= data => {//信息补充核实
    return $http({
        url: complaintPath + 'informationSupplement',
        data,
        method: 'POST'
    });
};
export const attention= data => {//关注和取消关注
    return $http({
        url: complaintPath + 'accept/operation/attention',
        data,
        method: 'POST'
    });
};
export const getCenter= data => {//拆单和转办获取指挥中心列表
    return $http({
        url: complaintPath + 'getCenter',
        data,
        method: 'POST'
    });
};
export const transformation= data => {//转办
    return $http({
        url: complaintPath + 'accept/operation/transformation',
        data,
        method: 'POST'
    });
};
export const getPcenter= data => {//获取上报的指挥中心
    return $http({
        url: complaintPath + 'getPcenter',
        data,
        method: 'POST'
    });
};

export const report = data => {//上报
    return $http({
        url: complaintPath + 'report',
        data,
        method: 'POST'
    });
};
export const reportAgree = data => {//上报审核通过
    return $http({
        url: complaintPath + 'reportAgree',
        data,
        method: 'POST'
    });
};
export const reportDisagree = data => {//上报审核不通过
    return $http({
        url: complaintPath + 'reportDisagree',
        data,
        method: 'POST'
    });
};
export const dispense = data => {//分发
    return $http({
        url: complaintPath + 'accept/operation/dispense',
        data,
        method: 'POST'
    });
};
export const getDepartment = data => {//分发获取同级部门
    return $http({
        url: complaintPath + 'getDepartment',
        data,
        method: 'POST'
    });
};
export const queryDataAT = data => {//获取被投诉对象/投诉问题/具体详情
    return $http({
        url: complaintPath + 'complaint/publicCondition/queryDataAT',
        data,
        method: 'POST'
    });
};
export const getIntelligentClassify = data => {//获取智能分类
    return $http({
        url: complaintPath + 'publicCondition/getIntelligentClassify',
        data,
        method: 'POST'
    });
};
export const supervise = data => {//领导页面得督办
    return $http({
        url: complaintPath + 'accept/operation/supervise',
        data,
        method: 'POST'
    });
};
export const displaySuperviseInfo = data => {//督办回复查询提交记录
    return $http({
        url: complaintPath + 'accept/operation/displaySuperviseInfo',
        data,
        method: 'POST'
    });
};
export const saveSuperviseReply = data => {//督办回复保存
    return $http({
        url: complaintPath + 'accept/operation/saveSuperviseReply',
        data,
        method: 'POST'
    });
};
export const superviseReply = data => {//督办回复
    return $http({
        url: complaintPath + 'accept/operation/superviseReply',
        data,
        method: 'POST'
    });
};
export const verifyAgree = data => {//拆单通过
    return $http({
        url: complaintPath + 'applySplitOrder/verifyAgree',
        data,
        method: 'POST'
    });
};
export const verifyDisagree = data => {//拆单不通过
    return $http({
        url: complaintPath + 'applySplitOrder/verifyDisagree',
        data,
        method: 'POST'
    });
};
export const buttonPower = data => {//拆单不通过
    return $http({
        url: complaintPath + 'qywx/buttonPurview/buttonPower',
        data,
        method: 'POST'
    });
};
export const getEnterprise = data => {//模糊查询企业
    return $http({
        url: complaintPath + 'getEnterprise',
        data,
        method: 'POST'
    });
};
export const notifyDepartment = data => {//告知部门
    return $http({
        url: complaintPath + 'notifyDepartment',
        data,
        method: 'POST'
    });
};
export const signCase = data => {//诉转案
    return $http({
        url: complaintPath + 'signCase',
        data,
        method: 'POST'
    });
};
export const recordCase = data => {//立案
    return $http({
        url: complaintPath + 'recordCase',
        data,
        method: 'POST'
    });
};
export const refuseCase = data => {//不予立案
    return $http({
        url: complaintPath + 'refuseCase',
        data,
        method: 'POST'
    });
};
export const completeCase = data => {//结案
    return $http({
        url: complaintPath + 'completeCase',
        data,
        method: 'POST'
    });
};
export const revokeCase = data => {//撤案
    return $http({
        url: complaintPath + 'revokeCase',
        data,
        method: 'POST'
    });
};
export const caseList = data => {//诉转案待处理
    return $http({
        url: complaintPath + 'qywx/complainToCase/list',
        data,
        method: 'POST'
    });
};
export const queryApplyVerifyList = data => {//申诉审核列表
    return $http({
        url: complaintPath + 'complaint/feedBack/queryApplyVerifyList',
        data,
        method: 'POST'
    });
};
export const departmentFeedBack = data => {//部门反馈
    return $http({
        url: complaintPath + 'accept/operation/departmentFeedBack',
        data,
        method: 'POST'
    });
};
export const getFreeBack = data => {//反馈保存草稿获取
    return $http({
        url: complaintPath + 'accept/operation/getFreeBack',
        data,
        method: 'POST'
    });
};
export const saveFeedBack = data => {//反馈保存草稿
    return $http({
        url: complaintPath + 'accept/operation/saveFeedBack',
        data,
        method: 'POST'
    });
};
export const conTractlist = data => {//电子合同列表
    return $http({
        url: complaintPath + 'qywx/electronicContract/list',
        data,
        method: 'POST'
    });
};
export const conTractunBindList = data => {//解绑电子合同列表
    return $http({
        url: complaintPath + 'qywx/electronicContract/unBindList',
        data,
        method: 'POST'
    });
};
export const supplementMaterials = data => {//补充办结材料提交
    return $http({
        url: complaintPath + 'supplementMaterials',
        data,
        method: 'POST'
    });
};
export const saveSupplementContent = data => {//补充办结材料保存
    return $http({
        url: complaintPath + 'saveSupplementContent',
        data,
        method: 'POST'
    });
};
export const supplementDetail = data => {//补充办结材料获取
    return $http({
        url: complaintPath + 'supplementDetail',
        data,
        method: 'POST'
    });
};
export const revocation = data => {//补充办结材料获取
    return $http({
        url: complaintPath + 'revocation',
        data,
        method: 'POST'
    });
};
export const getElectronicToken = data => {//获取电子合同的tonken
    return $http({
        url: complaintPath + 'getElectronicToken',
        data,
        method: 'POST'
    })
};
export const operation = data => {//电子合同的绑定和解绑
    return $http({
        url: complaintPath + 'qywx/electronicContract/operation',
        data,
        method: 'POST'
    })
};

export const appealVerifyAgree = data => {// 申诉审核通过
    return $http({
        url: complaintPath + 'complain/appealVerifyAgree',
        data,
        method: 'POST'
    });
};
export const appealVerifyDisagree = data => {// 申诉审核不通过
    return $http({
        url: complaintPath + 'complain/appealVerifyDisagree',
        data,
        method: 'POST'
    });
};
export const supplementEvidence = data => {// 游客补充证据
    return $http({
        url: complaintPath + 'supplementEvidence',
        data,
        method: 'POST'
    });
};
export const centerFeedBack = data => {// 游客补充证据
    return $http({
        url: complaintPath + 'accept/operation/centerFeedBack',
        data,
        method: 'POST'
    });
};
export const  apomentList= data => {// 考核跳转投诉列表
    return $http({
        url: complaintPath + 'penetrate/assessToComplain/list',
        data,
        method: 'POST'
    });
};
export const  apomentInfo= data => {// 考核跳转投诉详情基础详情数据
    return $http({
        url: complaintPath + 'penetrate/shared/info',
        data,
        method: 'POST'
    });
};
export const  syntheticalWarning= data => {// 综合预警列表
    return $http({
        url: complaintPath + 'newWorkbench/list/syntheticalWarning',
        data,
        method: 'POST'
    });
};

export default {
    menuList,
    syntheticalWarning,
    // syntheticalWarning,
    // emergency,
    // timeLimit,
    appealVerifyAgree,
    appealVerifyDisagree,
    recordCase,
    queryVerifyList,
    notHandleComplainList,
    listSuperviseToAccept,
    listAwaitReport,
    listDepEnterpriseAwaitHandle,
    detailInfo,
    notAcceptComplainList,
    unAccept,
    informationSupplement,
    attention,
    getCenter,
    transformation,
    getPcenter,
    report,
    reportAgree,
    reportDisagree,
    dispense,
    getDepartment,
    queryList,
    queryDataAT,
    supervise,
    displaySuperviseInfo,
    saveSuperviseReply,
    superviseReply,
    verifyAgree,
    verifyDisagree,
    buttonPower,
    getEnterprise,
    notifyDepartment,
    signCase,
    refuseCase,
    completeCase,
    revokeCase,
    caseList,
    queryApplyVerifyList,
    departmentFeedBack,
    getFreeBack,
    saveFeedBack,
    conTractlist,
    supplementMaterials,
    supplementDetail,
    saveSupplementContent,
    revocation,
    getElectronicToken,
    operation,
    centerFeedBack,
    conTractunBindList,
    supplementEvidence,
    apomentList,
    apomentInfo,
    getIntelligentClassify
}